import BtnDefault from './buttons/BtnDefault';
import ScreenContainer from '../display/ui/ScreenContainer';

export default class OverlayExplainer extends ScreenContainer {
  constructor(game, bmd, vo, characterId, rating) {
    super(game);

    //
    this.vo = vo;

    //
    this.onClick = new Phaser.Signal();

    this.bg = this.game.make.graphics();
    this.bg.beginFill(0x000000, 0.6);
    this.bg.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
    this.bg.endFill();
    this.addChild(this.bg);

    //
    this.bubble = this.game.make.image(0, 0, 'explain_bubble');
    this.character = this.game.make.image(23, 15, bmd);
    this.bubble.addChild(this.character);

    this.bubble.x = (this.game.defaultWidth - this.bubble.width) * 0.5;
    this.bubble.y = 130;

    this.addChild(this.bubble);

    characterId;
    rating;

    //
    this.btnClose = new BtnDefault({ game: this.game, id: 'close', icon: 'close' });
    this.addChild(this.btnClose);
    this.btnClose.x = (this.game.defaultWidth + this.game.width) * 0.5 - this.btnClose.width - 20;
    this.btnClose.y = 20;
    this.btnClose.onInputDown.addOnce(this.handleInputDown, this);
    this.addChild(this.btnClose);

    // lock content under
    this.bg.inputEnabled = true;

    //
    this.bg.events.onInputDown.addOnce(this.handleInputDown, this);

    // vo sligtly delayed
    this.game.time.events.add(500, this.handleVoComplete, this);
  }

  positionContainer() {
    super.positionContainer();
    if (this.btnClose) {
      this.btnClose.x = (this.game.defaultWidth + this.game.width) * 0.5 - this.btnClose.width - 20;
    }
  }

  handleVoComplete() {
    if (!this.closed) {
      if (this.vo.length > 0) {
        this.sound = this.game.sounds.playVO(this.vo.shift(), {
          spriteID: 'vo_gameplay',
          onComplete: this.handleVoComplete,
          onCompleteScope: this,
        });
      }
    }
  }

  handleInputDown() {
    this.btnClose.onInputDown.remove(this.handleInputDown, this);
    this.bg.events.onInputDown.remove(this.handleInputDown, this);

    this.closed = true;
    if (this.sound) {
      this.sound.stop();
    }
    this.sound = null;
    this.onClick.dispatch();
  }
}
